import { apiFetch } from "@/lib/api";
import { type AuthUser, useAuthStore } from "@/features/auth/store/auth-store";

/** Standard Django envelope — see features/auth/api.ts for the pattern. */
interface Envelope<T> {
  success: boolean;
  message: string;
  data: T;
}

/**
 * POST /firm/onboarding/complete. Stamps the firm's onboarding-complete flag
 * (idempotent server-side) and returns the refreshed user payload — the same
 * snake_case shape the auth store already holds. We write it straight back so
 * the nested `firm.onboarding_completed` flips to true and the OnboardingGate
 * stops redirecting. Called by the wizard's Finish button and its global
 * "I'll do this later" skip alike.
 */
export async function completeOnboarding(): Promise<AuthUser> {
  const { data } = await apiFetch<Envelope<AuthUser>>("/firm/onboarding/complete", {
    method: "POST",
  });
  useAuthStore.getState().setUser(data);
  return data;
}

// The per-step data writes reuse the existing feature clients unchanged —
// re-exported here so the step components have a single onboarding import.
// (Signature/logo/e-Services/team steps import their APIs from their own feature
// modules directly; these are the firm-profile/settings writes.)
export { getFirm, updateFirm, updateFirmSettings } from "@/features/settings/firm-api";
